/* Api service for billing's http endpoints */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HostService } from '@vendasta/billing';
import { Observable } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import { handleCsvError } from '../http-shared/error-handlers';
import { DownloadMerchantReportCsvRequest } from './merchant-report.interfaces';

@Injectable({ providedIn: 'root' })
export class MerchantReportApiService {
  constructor(private hostService: HostService, private http: HttpClient) {}

  downloadCsv(r: DownloadMerchantReportCsvRequest): Observable<Blob> {
    const queryParams = `?merchantID=${r.merchantId}&year=${r.year}&month=${r.month}`;
    return this.http
      .get(this.hostService.hostWithScheme + '/billing-report/get' + queryParams, this.apiOptions())
      .pipe(share(), catchError(handleCsvError));
  }

  generateCsv(r: DownloadMerchantReportCsvRequest): Observable<Blob> {
    const queryParams = `?merchantID=${r.merchantId}&year=${r.year}&month=${r.month}`;
    return this.http
      .get(this.hostService.hostWithScheme + '/billing-report/generate' + queryParams, this.apiOptions())
      .pipe(share(), catchError(handleCsvError));
  }

  private apiOptions(): { responseType: 'blob'; withCredentials: boolean } {
    return {
      responseType: 'blob',
      withCredentials: true,
    };
  }
}
